import React, { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TaskCategories from './components/TaskCategories';
import FeaturedProducts from './components/FeaturedProducts';
import StarterKits from './components/StarterKits';
import BatterySystem from './components/BatterySystem';
import ProductComparison from './components/ProductComparison';
import Reviews from './components/Reviews';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

function App() {
  const [cartCount, setCartCount] = useState(0);

  const handleAddToCart = (item) => {
    setCartCount(prev => prev + 1);
    // In a real app, you'd show a toast notification here
  };

  return (
    <div className="min-h-screen bg-gray-50 font-sans text-slate-800 selection:bg-lime-400 selection:text-slate-900">
      <Navbar cartCount={cartCount} />
      <main>
        <HeroSection />
        <TaskCategories />
        <FeaturedProducts onAddToCart={handleAddToCart} />
        <StarterKits onAddToCart={handleAddToCart} />
        <BatterySystem />
        <ProductComparison />
        <Reviews />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}

export default App;